import React, { useState, useEffect } from "react"
import styled from "styled-components"

const RawMessage = styled.div`
  color: ${props => props.theme.gray6};
  border: 1px solid ${props => props.theme.gray1};
  border-radius: 8px;

  .text {
    padding: 8px;
    color: ${props => props.theme.gray5};
    white-space: pre-wrap;

    &.header {
      border-bottom: 1px solid ${props => props.theme.gray1};
      font-weight: bold;
    }

    &.raw {
      font-size: ${props => props.theme.textSm};
      word-break: break-word;
    }
  }

  .read-more {
    border-top: 1px solid ${props => props.theme.gray1};
    padding: 0 16px;
    text-align: center;
    cursor: pointer;
    height: 44px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;;

    &:hover {
      background-color: ${props => props.theme.palerBackground};
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
`

const Raw = (data) => {
  const [readMore, setReadMore] = useState(false)
  const [messageText, setMessageText] = useState("")

  useEffect(() => {
    setMessageText(readMoreDisplay(data))
  }, [data, readMore])

  const readMoreDisplay = (message) => {
    let modText = JSON.stringify(message, null, 2)
    if (modText && modText.length > 200) {
      const sliced = modText.slice(0, 199)
      modText = (
        <div className="text-wrapper">
          <div className="text raw">{sliced}</div>
          <div
            className="read-more"
            onClick={() => {
              setReadMore(true)
            }}
          >
            Show More
          </div>
        </div>
      )
    } else {
      modText = (<div className="text raw">{JSON.stringify(message, null, 2)}</div>)
    }
    if (readMore) {
      modText = (<div className="text raw">{JSON.stringify(message, null, 2)}</div>)
    }
    return modText
  }

  return (
    <RawMessage>
      <div className="text header">Message could not be rendered.</div>
      {messageText}
    </RawMessage>
  )
}

export default Raw
